import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as r, createElementBlock as d, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconMultiLineDept",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function m(e, t, l, p, _, a) {
  return r(), d("svg", {
    "aria-label": l.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--multi-line-dept"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Multi Line Dept",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.147 1.147a.5.5 0 0 1 .707 0l1.5 1.5a.5.5 0 0 1 0 .707l-1.5 1.5a.5.5 0 0 1-.707-.707l.646-.647H6a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h2.793l-.646-.646a.5.5 0 0 1 .707-.707l1.5 1.5a.5.5 0 0 1 0 .707l-1.5 1.5a.5.5 0 1 1-.707-.707l.646-.647H6A1.5 1.5 0 0 1 4.5 8V6.5h-3a.5.5 0 0 1 0-1h3V4A1.5 1.5 0 0 1 6 2.5h2.793l-.646-.646a.5.5 0 0 1 0-.707Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, u);
}
const b = /* @__PURE__ */ s(c, [["render", m]]);
export {
  b as default
};
//# sourceMappingURL=multi-line-dept.js.map
